import { memo } from "react";
import { Shield, CreditCard, Clock, Lock, Award, Users } from "lucide-react";

const badges = [
  {
    icon: Shield,
    label: "Sin tarjeta requerida",
    subtext: "90 días gratis",
  },
  {
    icon: CreditCard,
    label: "0% comisiones",
    subtext: "Tú recibes todo",
  },
  {
    icon: Clock,
    label: "Activa en 2 min",
    subtext: "Setup instantáneo",
  },
  {
    icon: Lock,
    label: "Datos seguros",
    subtext: "Encriptación SSL",
  },
  {
    icon: Award,
    label: "Garantía 30 días",
    subtext: "Satisfacción total",
  },
  {
    icon: Users,
    label: "+2,500 profesionales",
    subtext: "Confían en nosotros",
  },
];

export const TrustBadgesStrip = memo(() => {
  return (
    <section className="py-8 border-y border-border/50 bg-muted/30">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
          {badges.map((badge, index) => (
            <div
              key={index}
              className="flex flex-col items-center text-center group"
            >
              <div className="p-3 rounded-full bg-primary/10 group-hover:bg-primary/20 transition-colors mb-2">
                <badge.icon className="w-5 h-5 text-primary" />
              </div>
              <span className="text-sm font-medium">{badge.label}</span>
              <span className="text-xs text-muted-foreground">{badge.subtext}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
});

TrustBadgesStrip.displayName = "TrustBadgesStrip";
